<template>
  <router-view></router-view>
</template>

<script>
import { useAuthStore } from './stores/auth'
import { useFeaturesStore } from './stores/features'

export default {
  name: 'App',
  async mounted() {
    const authStore = useAuthStore()
    const featuresStore = useFeaturesStore()

    await authStore.initializeAuth()

    // Load features once when the app initializes
    await featuresStore.loadFeatures()

    document.title = 'Appointum'
  }
}
</script>

<style>

*, *::before, *::after {
  font-family: 'Tilda Sans', sans-serif !important;
}
</style>